import { render, staticRenderFns } from "./ListaVersoes.vue?vue&type=template&id=5b7e9356&scoped=true&"
import script from "./ListaVersoes.vue?vue&type=script&lang=js&"
export * from "./ListaVersoes.vue?vue&type=script&lang=js&"
import style0 from "./ListaVersoes.vue?vue&type=style&index=0&id=5b7e9356&scoped=true&lang=css&"
import style1 from "./ListaVersoes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e9356",
  null
  
)

export default component.exports